import { render, staticRenderFns } from "./P1-0.vue?vue&type=template&id=edfad58e&scoped=true"
import script from "./P1-0.vue?vue&type=script&lang=js"
export * from "./P1-0.vue?vue&type=script&lang=js"
import style0 from "./P1-0.vue?vue&type=style&index=0&id=edfad58e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfad58e",
  null
  
)

export default component.exports